<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid manage-suppliers">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>Edit system user</h4>
            <editUsersForm></editUsersForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import EditUsersForm from "./EditUsersForm.vue";
export default {
  name: "ManageUsers",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    editUsersForm: EditUsersForm,
  },
  methods: {
    setActiveMenuItem: function () {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageUsers",
        activeMenu: this.activeMenu ? this.activeMenu : "security",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.manage-suppliers {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
